import axios from 'axios'

import env from '../environments'

export type OnboardingData = Record<string, unknown>

export async function postOnboarding(data: OnboardingData[]) {
	await axios.post(`${env.apiUrl}/onboardings`, {
		data
	})
}
